//deps
import React from "react";

interface LinkWalletState {
    mobileNumber: string;
}

export type LinkWalletContextValue = {
    setLinkWalletState: React.Dispatch<LinkWalletState>;
    linkWalletState: LinkWalletState;
};

export const LinkWalletContext = React.createContext<LinkWalletContextValue>({
    linkWalletState: { mobileNumber: "" },
    setLinkWalletState: () => void 0,
});

if (__DEV__) {
    LinkWalletContext.displayName = "LinkWalletContext";
}
